import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import SearchBars from 'components/SearchBars';
import Card from 'components/Card';
import { observer, inject } from 'mobx-react';
import InvoicesTable, { INVOICE_COLUMNS, INVOICE_CARDS, INVOICE_MIN_TABLE_WIDTH } from 'components/Tables/Invoices';
import * as DataList from 'components/DataList';
import Sticky from 'react-stickynode';
import styled from '@emotion/styled';

const PageWrapGray = styled('div')`
  padding: 8px 12px;
  background-color: #F8FAFB;
  min-height: calc(100vh - 75px);
`

@inject('store', 'invoiceStore', 'viewStore') @observer
class InvoicesIndexPage extends Component {

  render() {
    let content;
    let {
      invoiceStore: {
        invoices: {
          isLoading,
          isError
        }
      }
    } = this.props;
    if (isLoading && !isError) {
      content = (
        <DataList.Loading
          columns={INVOICE_COLUMNS}
          cards={INVOICE_CARDS}
          minTableWidth={INVOICE_MIN_TABLE_WIDTH}
          noun="invoices"
        />
      );
    }
    if (isError && !isLoading) {
      content = <DataList.LoadError noun="invoices" onRetry={() => this.props.invoiceStore.loadInvoices()} />;
    }
    if (!isError && !isLoading) {
      content = <InvoicesTable />
    }
    return (
      <div>
        <Helmet>
          <title>Invoices | FieldNexus</title>
        </Helmet>
        <PageWrapGray>
        <Sticky enabled={true} top={0} innerZ={9}>          
            <SearchBars.Invoice key={this.props.viewStore.listFiltersVersion} />         
        </Sticky>
          <Card>
            {content}
          </Card>
        </PageWrapGray>
      </div>
    )
  }
  

};

export default InvoicesIndexPage;